import React from "react";

const formatShortDate = (date) => {
  if (!date) return null;
  return new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const ProductBatches = ({ batches = [] }) => {
  const today = new Date();

  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Batch-wise Stock</h3>
      {batches.length === 0 ? (
        <p className="text-gray-400 text-sm">No batch records for this product.</p>
      ) : (
        <div className="space-y-2">
          {batches.map((b, idx) => {
            const isExpired = b.expiry_date && new Date(b.expiry_date) < today;
            const isNextToSell = idx === 0 && !isExpired;
            return (
              <div
                key={b._id}
                className={`flex items-center justify-between p-3 rounded-lg border ${
                  isExpired ? "bg-red-50 border-red-200" : isNextToSell ? "bg-green-50 border-green-300" : "bg-white border-gray-200"
                }`}
              >
                <div>
                  <p className="text-sm font-semibold text-gray-800">
                    {b.batch_number}
                    {isNextToSell && (
                      <span className="ml-2 text-[10px] bg-green-600 text-white px-2 py-0.5 rounded-full">
                        Next to sell (FEFO)
                      </span>
                    )}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {b.expiry_date ? `Expires: ${formatShortDate(b.expiry_date)}` : "No expiry tracked"}
                    {isExpired && <span className="text-red-600 font-semibold ml-2">EXPIRED</span>}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-gray-900">{b.quantity}</p>
                  <p className="text-[11px] text-gray-400">units left</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductBatches;